import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { addDisplayName } from "../Infra/display-name";
import { PatientConsentPDDEGDUBaseAnimatingComponent } from "./PatientConsentPDDEGDUBaseAnimatingComponent";
import { ConfirmButton } from "./PatientConsentManagerShared.styles";
import { FastenButtonContainer } from "./FastenButtonContainer";
export const DocumentRetrievalContinueWithoutSharing = observer((props) => {
    const { t } = useTranslation(["patients"]);
    const [isLoading, setIsLoading] = React.useState(false);
    const handleConfirmContinue = async () => {
        if (isLoading)
            return;
        setIsLoading(true);
        await props.onConfirmContinue();
    };
    return (_jsx(PatientConsentPDDEGDUBaseAnimatingComponent, { title: props.isIAS ? t("Continue without accessing records?") : t("Continue without sharing records?"), supportingText: props.isIAS
            ? t("By continuing without accessing records, you won’t get your HealthEx Unified Record.")
            : t("By continuing without sharing records, you won't share any records with {{ orgName }} for this request.", {
                orgName: props.organizationName,
            }), buttons: _jsxs(_Fragment, { children: [_jsx(ConfirmButton, { onClick: handleConfirmContinue, loading: isLoading, disabled: isLoading, children: t("Yes, continue") }), _jsx(FastenButtonContainer, { publicId: props.fastenPublicId, patientId: props.fastenPatientId, isStatic: props.isStatic, onAddAnotherClicked: props.onAddAnotherClicked, heapId: "continue-without-sharing-add-provider-button", buttonText: t("Add a provider") })] }) }));
});
addDisplayName(DocumentRetrievalContinueWithoutSharing, "DocumentRetrievalContinueWithoutSharing");
